import { ApiProperty } from "@nestjs/swagger";

export class EtdWiseDto {
    @ApiProperty()
    etdWiseId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    actualEdaDate: Date;
    @ApiProperty()
    revisedEdaDate: Date;
    @ApiProperty()
    unitId:number;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string;
    @ApiProperty()
    versionFlag: number;
}